import type { ReactNode } from 'react';

import type { Permission } from '../api/types';
import { useProject } from './context';

// Blendet Inhalte ohne Berechtigung aus. Die eigentliche Prüfung erfolgt immer serverseitig.
export function RequirePermission({ permission, children }: { permission: Permission; children: ReactNode }) {
  const { can } = useProject();
  if (!can(permission)) {
    return (
      <div className="page">
        <h1>Kein Zugriff</h1>
        <p className="muted">Für diesen Bereich fehlt Ihnen die Berechtigung in diesem Projekt.</p>
      </div>
    );
  }
  return children;
}
